import { AlertModal } from '@modusign/design-system';
import qs from 'qs';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Redirect, useParams } from 'react-router-dom';

import LoadingStatus from '@libs/loading-status';

import RootLoadingSpinnerComponent from '@app/components/Loading/RootLoadingSpinnerComponent';
import FetchRequesterLink from '@app/containers/FetchRequesterLink';
import { isAuthenticated as getIsAuthenticated } from '@app/store/account/selectors';
import { signOut } from '@app/store/account/sign-out/actions';
import { getLoadingStatus } from '@app/store/requesterLink/selectors';
import { getEmail } from '@app/store/user/user/selectors';

export interface DocumentLocationState {
  exitPath?: string;
}

const urlKeyUserEmail = 'user_email';

function DocumentsIdPage() {
  const dispatch = useDispatch();
  const location = useLocation<DocumentLocationState | undefined>();

  const isAuthenticated: boolean = useSelector(getIsAuthenticated);
  const email = useSelector(getEmail);
  const status = useSelector(getLoadingStatus);
  const { documentId } = useParams<{ documentId: string }>();
  const { pathname, search, hash } = useLocation();
  const queryUserEmail = qs.parse(search, { ignoreQueryPrefix: true })[urlKeyUserEmail] || '';

  // 로그인하지 않았다면 로그인페이지로 튕겨냅니다.
  // 쿼리에 이메일이 제공되었다면 해당 이메일로 로그인할 수 있도록 email 파라미터로 전달합니다.
  if (!isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: '/authentication/signin',
          search: qs.stringify({
            redirectTo: `${pathname}${search}${hash}`,
            email: queryUserEmail,
          }),
        }}
      />
    );
  }

  // 쿼리에 이메일이 제공되었다면, 현재 로그인한 이메일과 비교하여 다를때 로그아웃후 해당 계정으로 로그인할 수 있도록 합니다.
  if (queryUserEmail && queryUserEmail !== email) {
    return (
      <AlertModal
        isOpen
        maxWidth="xs"
        title="로그인 안내"
        variant="warning"
        onClose={() => dispatch(signOut())}
      >
        {queryUserEmail} 계정으로
        <br />
        로그인해 주세요.
      </AlertModal>
    );
  }

  // 문서의 상태에 따라 적절한 페이지로 이동시키기위해 <FetchRequesterLink />를 렌더합니다.
  return (
    <div className="align-center">
      {email && <FetchRequesterLink documentId={documentId} exitPath={location.state?.exitPath} />}
      <RootLoadingSpinnerComponent isLoading={status === LoadingStatus.PENDING} isOverlay />
    </div>
  );
}

export default DocumentsIdPage;
